import { Card, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { FileTextOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";

import TraiteFournDiv from "./TraiteFournDiv";
import TraiteFournSoins from "./TraiteFournSoins";
import DetailsActes from "./DetailsActes";


//import React from 'react'
const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Fournisseurs de soins",
  },
  {
    key: "2",
    label: "Fournisseurs Non Médicaux",
  },
  {
    key: "3",
    label: "Détails Actes",
  },

];

const Factures = () => {

  const [activeTabKey2, setActiveTabKey2] = useState("1");


  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <FileTextOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Traitements Factures
        </span>
      </div>
      <Card
        style={{
          width: "100%",
        }}
        styles={{ body: { paddingTop: 0 } }}
        tabList={tabListNoTitle}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
          size: "middle",
        }}
      >
      {activeTabKey2 === "1" && <TraiteFournSoins />}
        {activeTabKey2 === "2" && <TraiteFournDiv />}
        {activeTabKey2 === "3" && <DetailsActes />}
      </Card>
    </div>
  );
};

export default Factures;
